import classNames from "classnames";
import { DetailCardSection } from "../DetailCardSection";
import { HomePageFilterButtonSection } from "../HomePageFilterButtonSection";
import { useEffect } from "react";
import { Button } from "components/atoms";
import { getObjectKeysByValue } from "services/helpers";
import { useGetCourseworkQuery } from "services/homeApi";
import { useSegmentReFetch } from "context";
import {
  reStructureSegment,
  replaceArrayOfObjects,
} from "utils/functions/courseWorkReStructure";
import { getTimeFilterInput } from "utils/functions/getTimeFilterInput";
import { ai_mcat_chat_status } from "state/reducers/layoutSlice";
import { useAppSelector } from "hooks";
import "./index.scss";

interface IProps {
  theme: "light" | "dark";
}

export const Courseworks = ({ theme }: IProps) => {
  const {
    data,
    setData,
    selectedBtn,
    setSelectedBtn,
    selectedSession,
    setSelectedSession,
    page,
    setPage,
  } = useSegmentReFetch();

  const {
    data: remoteData,
    isLoading,
    isFetching,
    isError,
  } = useGetCourseworkQuery({
    page: page,
    selectedOption: parseInt(getObjectKeysByValue(selectedBtn, true)[0], 10),
    timeFilter:
      selectedSession === null
        ? 1
        : getTimeFilterInput(Object.values(selectedSession)[0]),
  });

    const { aiMCATChatDrawerStatus } = useAppSelector(
      (state: { layout: { aiMCATChatDrawerStatus: ai_mcat_chat_status } }) =>
        state.layout
    );

  useEffect(() => {
    if (remoteData && remoteData.Segments && page === 1) {
      const deStructuredArray = reStructureSegment(remoteData);
      setData([...deStructuredArray]);
    } else if (remoteData && remoteData.Segments) {
      const deStructuredArray = reStructureSegment(remoteData);
      setData((prev) => {
        const updated = replaceArrayOfObjects(deStructuredArray, prev);
        const existingIds = new Set(
          prev.map((segment) => segment.ProductOfferingSegmentId)
        );
        const newSegments = deStructuredArray.filter(
          (segment: any) => !existingIds.has(segment.ProductOfferingSegmentId)
        );
        return [...updated, ...newSegments];
      });
    }
  }, [page, remoteData]);

  const handleSelectedContentChange = (setPage: any) => {
    return (contentState: any) => {
      setSelectedBtn(contentState);
      setPage(1);
    };
  };

  const handleDropDownSelection = (setPage: any) => {
    return (session: any) => {
      setSelectedSession(session);
      setPage(1);
    };
  };

  return (
    <>
      <div className={classNames("home-page-filter-btn-section")}>
        <HomePageFilterButtonSection
          selectedBtn={selectedBtn}
          setSelectedBtn={handleSelectedContentChange(setPage)}
          setDropDownSelection={handleDropDownSelection(setPage)}
          selectedOption={selectedSession}
        />
      </div>
      <div className={classNames("home-page-detail-card-section")}>
        <DetailCardSection
          selectedBtn={selectedBtn}
          selectedSession={selectedSession}
          data={data}
          theme={theme}
          isLoading={isLoading}
          isError={isError}
          isFetching={isFetching}
        />
      </div>
      {isError || isLoading ? null : (
        <div className={classNames("home-page-bottom-btn-section",aiMCATChatDrawerStatus === "closed"
          ? "home-page-bottom-btn-section-ai-chat-drawer-closed"
          : "")}>
          <Button
            icon={false}
            type="score"
            styles="bottom-button-section-btn"
            label="Load More Segments"
            onClick={() => setPage((prev) => prev + 1)}
            isLoading={isFetching}
            isDisabled={remoteData?.Total === data.length}
          />
        </div>
      )}
    </>
  );
};
